import React from "react";
import classes from "./CrmComp.module.css";

// Shared "where did this record come from" pill used across the timeline
// row + standalone Emails / Calls / Tasks / Meetings tabs.
//
// Per the backend contract (2026-05-25 handoff), `record_type_for_crm`
// surfaces one of three Title Case strings, case-sensitive:
//   "Marketing Campaign" -> blue   (campaign flow)
//   "Sales Sequence"     -> purple (sequence flow)
//   "Manual"             -> indigo (user-created via CRM UI)
//
// Google-Calendar-synced meetings come back with `record_type_for_crm:
// null` and `type: "CRM"`. Callers can pass calendarFallback to render a
// 4th "Calendar" pill in that case; otherwise null inputs render nothing.
//
// The normalisation step (.trim().toLowerCase()) is defensive in case a
// legacy lowercase row slips through during the backfill - the chip still
// renders the canonical Title Case label.
const SourceTypeChip = ({ recordType, calendarFallback = false }) => {
  if (!recordType || typeof recordType !== "string") {
    if (!calendarFallback) return null;
    return (
      <span
        className={`${classes.emailSourceChip} ${classes.emailSourceChipCalendar}`}
      >
        Calendar
      </span>
    );
  }
  const normalized = recordType.trim().toLowerCase();
  let variantClass;
  let label;
  if (normalized === "sales sequence") {
    variantClass = classes.emailSourceChipSequence;
    label = "Sales Sequence";
  } else if (normalized === "marketing campaign") {
    variantClass = classes.emailSourceChipCampaign;
    label = "Marketing Campaign";
  } else if (normalized === "manual") {
    variantClass = classes.emailSourceChipManual;
    label = "Manual";
  } else {
    // Unknown source - render the raw string so we don't silently drop a
    // future backend value. Falls through with the neutral palette.
    variantClass = classes.emailSourceChipManual;
    label = recordType;
  }
  return (
    <span className={`${classes.emailSourceChip} ${variantClass}`}>
      {label}
    </span>
  );
};

export default SourceTypeChip;
